<template>
  <div id="publicSettingDiv">
    <div class="publicSettingDiv_content">
      <div class="publicSetting_head_title">
        <div class="head_title_font publicSetting_head_title_font" style="max-width: 100%;">
          干部培训课程质量评估标准
          <button type="button" class="btn btn-default btn_option" data-toggle="modal" data-target="#templateModal" style="float:right;" @click="add(1)">+ 新增</button>
        </div>
      </div>
      <div class="">
        <table class="table table-striped table-bordered">
          <tbody>
            <tr>
              <th width="20%">标题</th>
              <th>评估项</th>
              <th width="10%">状态</th>
              <th width="10%">最后启用时间</th>
              <th width="15%">操作</th>
            </tr>
            <tr v-for="(template, index) in templateList" :key="index"  v-if="template.type==1">
              <td>{{template.title}}</td>
              <td><span v-for="(item,ii) in template.items"><span :style="item.type=='1'?{fontWeight:'bold'}:{}">{{item.title}}({{item.maxValue}}分)</span><span v-if="template.items.length-1 !== ii"> ，</span></span></td>
              <td>{{statusLabel[template.status]}}</td>
              <td>{{template.lastTime}}</td>
              <td>
                <div v-if="template.status != '1'" class="enable_pic" @click="enable(template)" data-toggle="tooltip" data-placement="bottom" title="启用"></div>
                <div v-if="template.status == '0'" class="edit_pic" @click="edit(template)" data-toggle="tooltip" data-placement="bottom" title="修改"></div>
                <div v-if="template.status == '0'" class="delete_pic" @click="del(template)" data-toggle="tooltip" data-placement="bottom" title="删除"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="publicSetting_head_title">
        <div class="head_title_font publicSetting_head_title_font" style="max-width: 100%;">
          党校教学质量评估标准
          <button type="button" class="btn btn-default btn_option" data-toggle="modal" data-target="#templateModal" style="float:right;" @click="add(2)">+ 新增</button>
        </div>
      </div>
      <div class=" ">
        <table class="table table-striped table-bordered">
          <tbody>
          <tr>
            <th width="20%">标题</th>
            <th>评估项</th>
            <th width="10%">状态</th>
            <th width="10%">最后启用时间</th>
            <th width="15%">操作</th>
          </tr>
          <tr v-for="(template, index) in templateList" :key="index"  v-if="template.type==2">
            <td>{{template.title}}</td>
            <td><span v-for="(item,ii) in template.items"><span :style="item.type=='1'?{fontWeight:'bold'}:{}">{{item.title}}({{item.maxValue}}分)</span><span v-if="template.items.length-1 !== ii"> ，</span></span></td>
            <td>{{statusLabel[template.status]}}</td>
            <td>{{template.lastTime}}</td>
            <td>
              <div v-if="template.status != '1'" class="enable_pic" @click="enable(template)" data-toggle="tooltip" data-placement="bottom" title="启用"></div>
              <div v-if="template.status == '0'" class="edit_pic" @click="edit(template)" data-toggle="tooltip" data-placement="bottom" title="修改"></div>
              <div v-if="template.status == '0'" class="delete_pic" @click="del(template)" data-toggle="tooltip" data-placement="bottom" title="删除"></div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal fade" id="templateModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content" style="width: 800px">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">评估模板</h4>
          </div>
          <div class="modal-body">
            <div>
              <label class="my_label">标题：</label>
              <input id="title" v-validate="'required'" data-vv-scope="questionnaireInfo" data-vv-as="标题" name="title" class="form-control" v-model="questionnaireInfo.title" placeholder="输入标题">
              <span class="spanRed">*</span>
              <span class="validateTip">{{ errors.first('questionnaireInfo.title') }}</span>
            </div>
            <div>
              <table class="table table-striped table-bordered ">
                <tbody>
                <tr>
                  <th width="5%">#</th>
                  <th width="20%">类型</th>
                  <th width="40%">评估项</th>
                  <th width="20%">分值</th>
                  <th>操作<button type="button" class="btn btn-default btn_option btn_add" style="float:right;" @click="addItem()"> + </button></th>
                </tr>
                <tr v-for="(item, index) in questionnaireItemList">
                  <td>{{index + 1}}</td>
                  <td @click="editCell(index, 3)">
                    <span v-if="currEditIndex != index || currEditCell != 3" >{{item.type == '1'?"——":"|"}}</span>
                    <select class="form-control" v-model="item.type" v-if="currEditIndex == index && currEditCell == 3">
                      <option value="0" selected>评估项</option>
                      <option value="1" selected>小标题</option>
                    </select>
                  </td>
                  <td @click="editCell(index, 1)">
                    <span v-if="currEditIndex != index || currEditCell != 1" :style="item.type=='1'?{fontWeight:'bold'}:{}">{{ item.title }}</span>
                    <input v-if="currEditIndex == index && currEditCell == 1" type="text" class="form-control classInfo" :placeholder="item.type == '1'?'输入小标题':'输入评估项'" v-model="item.title" autocomplete="off"/>
                  </td>

                  <td @click="editCell(index, 2)">
                    <span v-if="(currEditIndex != index || currEditCell != 2)" :style="item.type=='1'?{fontWeight:'bold'}:{}">{{ item.maxValue }}</span>
                    <input v-if="currEditIndex == index && currEditCell == 2 && item.type !=1" type="number" class="form-control classInfo" placeholder="输入分值" v-model="item.maxValue" autocomplete="off"/>
                  </td>
                  <td>
                    <button type="button" class="btn btn-default btn_in_row" @click="goUp( index)" v-if="index != 0">↑</button>
                    <button type="button" class="btn btn-default btn_in_row" @click="goDown( index)" v-if="questionnaireItemList.length-index > 1">↓</button>
                    <button type="button" class="btn btn-default btn_in_row" @click="removeItem(index)">-</button>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td>总分</td>
                  <td>{{ totalValue }}</td>
                  <td></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" @click="saveTemplate()">确认</button>
            <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal -->
    </div>
  </div>

</template>

<script>
  import {getContentSize} from './mainView';

  import {schoolAxios} from '../main';

  export default {
    name: "questionnaireSetting",
    data() {
      return {
        //问卷对象
        questionnaireInfo:{
          id:'',
          items:[],
          title:'',
          type:''
        },
        questionnaireItemList: [],
        templateList:[],
        statusLabel:{
          "-1": "停用",
          "0": "编辑",
          "1": "启用",

        },
        currEditIndex:-1,
        currEditCell:0,
      }
    },
    filters: {

    },
    created: function () {

    },
    computed:{
      totalValue:function (){
        if(!this.questionnaireItemList) return 0;
        let t = 0;
        let tempMax = 0;
        let tempQ;
        this.questionnaireItemList.forEach(i => {
          if(i.type == '1'){
            if(tempQ && tempMax){
              tempQ.maxValue = tempMax;
            }
            tempQ = i;
            tempMax = 0;
          }else{
            tempMax += Number(i.maxValue);
            t+=Number(i.maxValue)
          }
        })
        if(tempQ && tempMax){
          tempQ.maxValue = tempMax;
        }
        return t;
      }
    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        //绑定加载关闭模态框时的事件
        this_.closeModal();

        this_.dateDefault();

        this_.initTemplateList();

      });
    },
    methods: {
      /**
       * 加载评估模版
       */
      initTemplateList(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'questionnaire/list',
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success) {
            this_.templateList = data.list;
            this_.templateList.forEach(item => item.items = JSON.parse(item.content))
          }
        });
      },

      add(type){
        this.closeModal();
        this.questionnaireInfo.type = type;
      },
      addItem(){
        if(!this.questionnaireItemList)
          this.questionnaireItemList = [];
        this.questionnaireItemList.push({type: "0", title:"", maxValue:"0"})
      },
      /**
       * 单击修改评估指标
       */
      edit(item){
        this.questionnaireInfo = item;
        this.questionnaireItemList = item.items;
        $("#templateModal").modal("show");
      },
      editCell(index, cell){
        this.currEditIndex = index;
        this.currEditCell = cell;
      },
      enable(item){
        let this_ = this;
        "确定发布模板吗？".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'questionnaire/enable/',
            params: {
              id: item.id
            }
          }).then(function (resp) {
            let data = resp.data;
            if (data.success) {
              this_.initTemplateList();
            } else {
              data.message.showMessage();
            }
          });
        })
      },
      del(item){
        let this_ = this;
        "确定删除模板吗？".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'questionnaire/delete/'+item.id,
            params: {}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.initTemplateList();
            }else{
              data.message.showMessage();
            }
          });
        });
      },

      // input(index1,index2){
      //   let this_ = this;
      //   if(index2!=-1){
      //     this_.evaluateItemList[index1].data[index2].flag=true;
      //   }else{
      //     this_.evaluateItemList[index1].flag=true;
      //   }
      // },

      // /**
      //  * 添加一级评估指标
      //  */
      // insert1:function(index1,index2){
      //   let this_ = this;
      //   /*let value_parent1 = {};
      //   for(let e in this_.value_parent){
      //     value_parent1[e] = this_.value_parent[e];
      //   }*/
      //   let value_parent=JSON.parse(JSON.stringify(this_.value_parent));
      //   this_.evaluateItemList.splice(index1+1, 0, value_parent);
      // },
      // /**
      //  * 添加二级评估指标
      //  */
      // insert2:function(index1,index2){
      //   let this_ = this;
      //   if(index2==0){
      //     //this_.evaluateItemList[index1].maxValue='';
      //     /*if(!this_.evaluateItemList[index1].data){
      //     this_.evaluateItemList[index1].data=[];
      //   }*/
      //     delete this_.evaluateItemList[index1].maxValue
      //   }
      //   /*let value_child = {};
      //   for(let i in this_.value_child){
      //     value_child[i] = this_.value_child[i];
      //   }*/
      //   let value_child=JSON.parse(JSON.stringify(this_.value_child));
      //   this_.evaluateItemList[index1].data.splice(index2, 0, value_child);
      //   this_.initTemplateList();
      // },
      /**
       * 删除一级评估指标及子指标
       */
      removeItem:function(index){
        this.questionnaireItemList.splice(index, 1);
      },

      /**
       * 上移
       */
      goUp:function(index){
        if(index!=0){
          this.questionnaireItemList[index] = this.questionnaireItemList.splice(index-1, 1, this.questionnaireItemList[index])[0];
        }else{
          fieldData.push(fieldData.shift());
        }
      },
      /**
       * 下移
       */
      goDown:function(index) {
        if(index!=this.questionnaireItemList.length-1){
          this.questionnaireItemList[index] = this.questionnaireItemList.splice(index+1, 1, this.questionnaireItemList[index])[0];
        }else{
          this.questionnaireItemList.unshift( this.questionnaireItemList.splice(index,1)[0]);
        }
      },

      // /**
      //  * 获取评估项
      //  */
      // getEvaluateItem(id,title){
      //   let this_ = this;
      //   schoolAxios({
      //     method: 'get',
      //     url: 'questionnaire/load/'+id,
      //     params: {}
      //   }).then(function (resp) {
      //     let data = resp.data;
      //     if(data.success){
      //       this_.questionnaireInfo=data.data;
      //     }
      //     if(data.data.content){
      //       this_.evaluateItemList = JSON.parse(data.data.content);
      //     }
      //   });
      //   this_.$bvModal.show('modal-questionnaire');
      // },



      /**
       * 修改评估模板
       */
      saveTemplate(){
        let this_ = this;
        /*计算评估总分*/
        let total=0;
        if(!this.questionnaireInfo.title){
          "标题不能为空".showMessage();
          return;
        }
       if(!this.questionnaireItemList){
         "还未添加评估项".showMessage();
         return;
       }
        if(this.questionnaireItemList.filter(i => !i.title ).length>0){
          "评估项都不能为空".showMessage();
          return;
        }
        if(this.questionnaireItemList.filter(i => i.type != '1' && (!i.maxValue || i.maxValue<=0)).length>0){
          "评分都不能为空且要大于0".showMessage();
          return;
        }
        // if(this.totalValue != 100){
        //   "总分必需是100分".showMessage();
        //   return;
        // }

        let url = "questionnaire/add"
        if(this.questionnaireInfo.id){
          url = "questionnaire/edit/" + this.questionnaireInfo.id
        }
        schoolAxios({
          method: "post",
          url: url,
          data: {
            id:this_.questionnaireInfo.id,
            content:JSON.stringify(this_.questionnaireItemList),
            title: this_.questionnaireInfo.title,
            type:this_.questionnaireInfo.type
          }
        }).then(function (resp) {
          let data = resp.data;
          if (data.success) {
            $("#templateModal").modal("hide");
            this_.initTemplateList();
          } else {
            data.message.showMessage();
          }
        });
      },

      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#templateModal").on('hide.bs.modal', function () {
          this_.questionnaireInfo = {
            id:'',
            items:[],
            title:'',
            type:''
          }
          this_.questionnaireItemList = [];
        });
      },
      /**
       * 初始化日期选这框
       */
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('#startDate').datetimepicker({
          minView: "month",//选择日期后，不会再跳转去选择时分秒
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,//选择一个日期后是否立即关闭此选择框
          todayHighlight: true,//高亮当前日期
          startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#startDate").val();
          this_.trainingManageInfo.startDate = value;

          ev.preventDefault();
          ev.stopPropagation();
        });
        $('#endDate').datetimepicker({
          minView: "month",
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          startView: 2,
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#endDate").val();
          this_.trainingManageInfo.endDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        });
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/questionnaireSetting.css";
</style>



// WEBPACK FOOTER //
// src/components/questionnaireSetting.vue